import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { statoNotifiche, attiva, disattiva } from './push';

const LABEL = {
  attive: 'Notifiche attive (tocca per disattivare)',
  da_attivare: 'Attiva notifiche',
  negato: 'Notifiche bloccate (Impostazioni iOS)',
  installa_safari: 'Installa da Safari per le notifiche',
  non_https: 'Notifiche: serve HTTPS (apri con https://)',
  non_supportata: 'Notifiche non supportate',
  errore: 'Attiva notifiche',
};

export default function NotifButton() {
  const [stato, setStato] = useState('da_attivare');
  const [busy, setBusy] = useState(false);

  useEffect(() => { statoNotifiche().then(setStato).catch(() => {}); }, []);

  const onClick = async () => {
    if (busy) return;
    if (stato === 'non_https') { toast.info('Le notifiche richiedono HTTPS: apri l\'app con https:// (non http://)', { duration: 9000 }); return; }
    if (stato === 'non_supportata' || stato === 'installa_safari') { toast.info(LABEL[stato]); return; }
    if (stato === 'negato') { toast.error('Sblocca le notifiche in Impostazioni iOS'); return; }
    setBusy(true);
    try {
      if (stato === 'attive') {
        setStato(await disattiva());
        toast.success('Notifiche disattivate');
      } else {
        const r = await attiva();
        setStato(r);
        if (r === 'attive') toast.success('Notifiche attivate');
        else if (r === 'negato') toast.error('Permesso negato: abilitale in Impostazioni iOS');
        else if (r === 'installa_safari') toast.info('Installa da Safari (Aggiungi a Home)');
      }
    } catch (e) { toast.error('Notifiche: ' + (e?.message || 'errore'), { duration: 8000 }); }
    setBusy(false);
  };

  return (
    <button className="m-fs" onClick={onClick} disabled={busy}>{LABEL[stato] || 'Attiva notifiche'}</button>
  );
}
